/* eslint-disable max-len */
import PropTypes from 'prop-types'
import React from 'react'
import styles from './_footer.css'
import classnames from 'classnames'
import Svg from 'components/util/Svg'
import phone from 'images/footer/i-phone.png'
import phone2x from 'images/footer/i-phone@2x.png'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import * as bootupSelectors from 'services/bootup/selectors'
import fitness from 'images/sites/fitness/logo.svg'
import walk from 'images/sites/walk/logo.svg'
import run from 'images/sites/run/logo.svg'
import ride from 'images/sites/ride/logo.svg'
import hike from 'images/sites/hike/logo.svg'

const logos = { fitness, walk, run, ride, hike }

const SITES = require('../../../shared/constants/sites')

const mapStateToProps = (state) => ({
  accountPortalRoot: bootupSelectors.selectAccountPortalRoot(state),
})

const propTypes = {
  accountPortalRoot: PropTypes.string,
  storeLink: PropTypes.string,
  site: PropTypes.shape({
    name: PropTypes.string,
  }),
  loggedIn: PropTypes.bool,
  locale: PropTypes.string,
  logIn: PropTypes.func,
}

export const Footer = function ({ accountPortalRoot, site, storeLink, loggedIn, locale, logIn }) {
  const otherSites = SITES.filter(({ key, slug }) => !['local', 'devint', 'uarun'].includes(key) && slug !== site.slug)

  const socialName = site.shortName === 'mapmyhike' ? 'mapmyrun' : site.shortName

  return (
    <footer className={styles.container}>
      <div>
        <div className={styles.inner}>
          <div className={styles.appStoreContainer}>
            <div className={styles.appStoreDescription}>
              <FormattedMessage
                id='site.footer.app_store-desc'
                defaultMessage='Track every mile you run, connect your devices, and get closer to your next PR.'
              />
            </div>
            <a className={styles.appStoreLink} target='_blank' rel='noopener noreferrer' href={site.appStoreLink}>
              <Svg className={styles.appStoreIcon} name='apple-app-store' />
            </a>
            <a className={styles.appStoreLink} target='_blank' rel='noopener noreferrer' href={`https://play.google.com/store/apps/details?id=com.${site.shortName}.android2&hl=en`}>
              <Svg className={styles.appStoreIcon} name='google-play-store' />
            </a>
          </div>
        </div>
      </div>

      <div className={styles.sites}>
        <div className={styles.inner}>
          <div className={styles.siteListContainer}>
            <div className={styles.currentSite}>
              <img className={styles.currentSiteIcon} src={logos[site.slug]} alt={site.name} />
            </div>
            <div className={styles.siteLinkContainer}>
              {otherSites.map((otherSite, i) => {
                return (
                  <a key={i} className={styles.siteLink} href={otherSite.canonical}>
                    <svg className={styles.otherSiteIcon}>
                      <use className={styles[`${otherSite.slug}-short`]} xlinkHref={`#${otherSite.slug}-short`} />
                    </svg>
                  </a>
                )
              })}
            </div>
          </div>
        </div>
      </div>

      <div className={styles.navLinksContainer}>
        <div className={styles.inner}>
          <div className={styles.phone}>
            <img src={phone} srcSet={`${phone2x} 2x`} />
          </div>
          <div className={styles.linksWrapper}>
            <ul className={styles.linksCol}>
              <li className={styles.linksHeader}>
                <FormattedMessage id='site.footer.linkheader.social' defaultMessage='Social' />
              </li>
              <li>
                <a className={styles.link} target='_blank' rel='noopener noreferrer' href={`http://www.facebook.com/${socialName}`}>
                  <FormattedMessage id='site.footer.fb' defaultMessage='Like us on Facebook' />
                </a>
              </li>
              <li>
                <a className={styles.link} target='_blank' rel='noopener noreferrer' href={`http://twitter.com/${socialName}`}>
                  <FormattedMessage id='site.footer.twitter' defaultMessage='Follow us on Twitter' />
                </a>
              </li>
              <li>
                <a className={styles.link} target='_blank' rel='noopener noreferrer' href='http://blog.mapmyrun.com/'>
                  <FormattedMessage id='site.footer.blog' defaultMessage='{name} Blog' values={{ name: site.name }} />
                </a>
              </li>
            </ul>
            <ul className={styles.linksCol}>
              <li className={styles.linksHeader}>
                <FormattedMessage id='site.footer.linkheader.help' defaultMessage='Help' />
              </li>
              <li>
                {!loggedIn ?
                  <a className={styles.link} href='/auth/login' onClick={() => logIn('login_register_footer')}>
                    <FormattedMessage id='site.footer.login' defaultMessage='Log In / Register' />
                  </a>
                :
                  <a className={styles.link} href='/account/settings'>
                    <FormattedMessage id='site.footer.accountsettings' defaultMessage='Account Settings' />
                  </a>
                }
              </li>
              <li>
                <a href='http://support.mapmyfitness.com/login' className={styles.link}>
                  <FormattedMessage id='site.footer.support' defaultMessage='Support' />
                </a>
              </li>
              <li>
                <a className={styles.link} target='_blank' rel='noopener noreferrer' href='https://developer.underarmour.com/'>
                  <FormattedMessage id='site.footer.api_docs' defaultMessage='Developer / API' />
                </a>
              </li>
            </ul>
            <ul className={styles.linksCol}>
              <li className={styles.linksHeader}>
                <FormattedMessage id='site.footer.linkheader.about' defaultMessage='About Us' />
              </li>
              <li>
                <a className={styles.link} href='https://advertising.underarmour.com/' target='_blank' rel='noopener noreferrer'>
                  <FormattedMessage id='site.footer.advertise' defaultMessage='Advertise' />
                </a>
              </li>
              <li>
                <a className={styles.link} href='https://boards.greenhouse.io/connectedfitness' target='_blank' rel='noopener noreferrer'>
                  <FormattedMessage id='site.footer.join' defaultMessage='Join Our Team' />
                </a>
              </li>
              <li>
                <a className={styles.link} href={storeLink} target='_blank' rel='noopener noreferrer'>
                  <FormattedMessage id='site.footer.shop' defaultMessage='Shop Under Armour' />
                </a>
              </li>
            </ul>
            <ul className={classnames(styles.linksCol, styles.appLinksCol)}>
              <li className={classnames(styles.linksHeader, styles.linksHeaderDesktop, styles.appLinksColHeader)}>
                <FormattedMessage id='site.footer.community' defaultMessage='UA Fitness Community' />
              </li>
              <li className={classnames(styles.linksHeader, styles.linksHeaderMobile, styles.appLinksColHeader)}>
                <FormattedMessage id='site.footer.community.largest' defaultMessage='The World&#39;s Largest Fitness Community' />
              </li>
              <li className={styles.appLinkContainer}>
                <a className={styles.appLink} target='_blank' rel='noopener noreferrer' href='https://itunes.apple.com/us/app/record-by-under-armour-connects/id895425891?mt=8'>
                  <div className={classnames(styles.appLinkIcon, styles.recordIcon)} />
                </a>
                <a className={styles.appLink} target='_blank' rel='noopener noreferrer' href='https://itunes.apple.com/us/app/running-walking-biking-endomondo/id333210180?mt=8'>
                  <div className={classnames(styles.appLinkIcon, styles.endoIcon)} />
                </a>
                <a className={styles.appLink} target='_blank' rel='noopener noreferrer' href='https://itunes.apple.com/us/app/calorie-counter-diet-tracker/id341232718?mt=8'>
                  <div className={classnames(styles.appLinkIcon, styles.mfpIcon)} />
                </a>
                <a className={styles.appLink} target='_blank' rel='noopener noreferrer' href='https://itunes.apple.com/us/app/map-my-fitness-gps-workout/id298903147?mt=8'>
                  <div className={classnames(styles.appLinkIcon, styles.mmfIcon)} />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div>
        <div className={styles.inner}>
          <div className={styles.subfooter}>
            <div className={styles.uaLogoContainer}>
              <a href={storeLink} target='_blank' rel='noopener noreferrer'>
                <Svg className={styles.uaLogo} name='ua-logo' />
              </a>
            </div>
            <div className={styles.legal}>
              <p className={styles.legalCopy}>
                <FormattedMessage
                  id='footer.copy_statement'
                  defaultMessage='© {year} Under Armour®, Inc. All rights reserved'
                  values={{ year: (new Date()).getFullYear() }}
                />
              </p>
              <ul className={styles.legalList}>
                <li className={styles.legalItem}>
                  <a className={styles.legalLink} target='_blank' rel='noopener noreferrer' href={`${accountPortalRoot}/privacy`}>
                    <FormattedMessage id='site.footer.privacy_policy' defaultMessage='Privacy Policy' />
                  </a>
                </li>
                <li className={styles.legalItem}>
                  <a className={styles.legalLink} target='_blank' rel='noopener noreferrer' href={`${accountPortalRoot}/terms-and-conditions`}>
                    <FormattedMessage id='site.footer.terms_of_use' defaultMessage='Terms of Use' />
                  </a>
                </li>
                <li className={styles.legalItem}>
                  <a className={styles.legalLink} target='_blank' rel='noopener noreferrer' href={`${accountPortalRoot}/privacy#interest-based-advertising`}>
                    <FormattedMessage id='site.footer.cookie_policy' defaultMessage='Cookie Policy' />
                  </a>
                </li>
                <li className={styles.legalItem}>
                  <span id="teconsent" className={styles.legalLink} />
                </li>
                <li className={styles.legalItem}>
                  <a className={styles.legalLink} target='_blank' rel='noopener noreferrer' href={`http://preferences-mgr.trustarc.com/?pid=underarmour01&aid=underarmour_pub01&locale=${locale}`}>
                    <FormattedMessage id='site.footer.adchoices' defaultMessage='AdChoices' />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

Footer.propTypes = propTypes

export default connect(mapStateToProps, {})(Footer)
